import { useEffect } from "react";
import { useCookieConsent } from "@/contexts/CookieConsentContext";

/**
 * Hook pour demander le consentement des cookies sur les pages qui nécessitent le tracking
 * À utiliser dans les composants qui effectuent du tracking (GA, etc.)
 */
export const useConsentRequired = () => {
  const { requestConsent, hasConsent } = useCookieConsent();

  useEffect(() => {
    // Demander le consentement si pas encore donné
    requestConsent();
  }, [requestConsent]);

  return {
    hasAnalyticsConsent: hasConsent('analytics')
  };
};
